import React from 'react';
import ImagePath from 'app/utilities/imagePath';
import EmptyState from 'app/components/EmptyState/EmptyState';
import { IEmptyState } from 'app/interfaces/empty-state/empty-state.interface';
import { IModalProps } from '../../interfaces/modalProps.interface';
import { nonRDLEmptyState } from '../../configs/nonRDL.config';
import './RDLModal.scss';

const RDLModal = function init(props: IModalProps): React.ReactElement {
    const { setOpenModal } = props;
    const emptyState: IEmptyState = nonRDLEmptyState;

    function closeModal(): void {
        setOpenModal(false);
    }

    return (
        <div className="mainContainer">
            <button
                className="imageContainer btn"
                type="button"
                onClick={() => closeModal()}
            >
                <img src={ImagePath.close.src} alt={ImagePath.close.alt} />
            </button>
            <div className="emptyStateContainer">
                <EmptyState
                    image={emptyState.image}
                    placeholder={emptyState.placeholder}
                    caption={emptyState.caption}
                />
            </div>
        </div>
    );
};

export default RDLModal;
